import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { mangaCategories } from '@/mocks/manga';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCategoryOpen, setIsCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsCategoryOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50 shadow-md'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="text-2xl font-bold text-accent-500">YY</span>
            <span className="text-lg font-semibold text-foreground-950">漫画网</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-accent-500'
                  : 'text-foreground-700 hover:text-accent-500'
              }`}
            >
              首页
            </Link>

            <div className="relative">
              <button
                onClick={() => setIsCategoryOpen(!isCategoryOpen)}
                className={`flex items-center gap-1 text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname.startsWith('/category')
                    ? 'text-accent-500'
                    : 'text-foreground-700 hover:text-accent-500'
                }`}
              >
                分类
                <i className={`ri-arrow-down-s-line transition-transform ${isCategoryOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {isCategoryOpen && (
                <div className="absolute top-full left-0 mt-2 w-48 bg-background-50 border border-background-200 rounded-lg shadow-lg py-2 z-50">
                  {mangaCategories.slice(0, 6).map((cat) => (
                    <Link
                      key={cat.id}
                      to={cat.id === 'all' ? '/category/all' : `/category/${cat.id}`}
                      className="flex items-center gap-2 px-4 py-2 text-sm text-foreground-700 hover:bg-accent-100 hover:text-accent-600 transition-colors"
                    >
                      <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-accent-500'
                  : 'text-foreground-700 hover:text-accent-500'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-48 px-4 py-2 text-sm rounded-full border border-background-300 bg-background-50 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-accent-500 transition-colors"
              />
              <i className="ri-search-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden pb-4 border-t border-background-200 bg-background-50">
            <div className="flex flex-col gap-2 pt-3">
              <Link to="/" className="px-4 py-2 text-sm text-foreground-700 hover:bg-accent-100 rounded-lg">
                首页
              </Link>
              {mangaCategories.slice(0, 6).map((cat) => (
                <Link
                  key={cat.id}
                  to={cat.id === 'all' ? '/category/all' : `/category/${cat.id}`}
                  className="px-4 py-2 text-sm text-foreground-700 hover:bg-accent-100 rounded-lg flex items-center gap-2"
                >
                  <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
                  {cat.name}
                </Link>
              ))}
              <Link to="/about" className="px-4 py-2 text-sm text-foreground-700 hover:bg-accent-100 rounded-lg">
                关于我们
              </Link>
              <div className="px-4 pt-2">
                <input
                  type="text"
                  placeholder="搜索漫画..."
                  className="w-full px-4 py-2 text-sm rounded-full border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-accent-500"
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}